/*
 *  Bootstrap Nice Select Spanish (Spain, International Sort) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['es-ES'] = localisation.locales['es'] = {
    formatSearch() {
        return "Buscando...";
    },
    formatHelpForTagging() {
        return "Para crear etiquetas propias, enfoque el campo de entrada y luego presione 'Entrar' o ',' o 'Barra espaciadora' para agregarlo a la lista";
    }
}

export default localisation;